import React from 'react';
import { ContentSection, Heading, PageWrap, Paragraph } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { trackingService } from '../../tracking/tracking.service';

export const SessionTimeoutPage: React.FC = () => {
  const { t } = useTranslation();

  React.useEffect(() => {
    trackingService.trackPageView('Legitimation timeout', 'Legitimation timeout');
  }, []);

  return (
    <PageWrap>
      <ContentSection className="u-text-center">
        <Heading level={3}>{t('errorPage:sessionTimeout:header')}</Heading>
        <Paragraph>{t('errorPage:sessionTimeout:content')}</Paragraph>
      </ContentSection>
    </PageWrap>
  );
};
